import { Ref, reactive, ref } from "vue";

export type State = {
  activeIndex: number,
  chapterToLoad: number | null,

  isListing: boolean,
  isGrabbing: boolean,
  isLoading: boolean,
  allowSwipe: boolean,
  showLoadingLight: boolean,
  showLoader: boolean,
  showNavigation: boolean,
  fontLoaded: boolean,
  loadProgress: number,
  
  scrollProgress: number,
  swipeX: number,
}

const initialChapter = process.env.VUE_APP_INITIAL_CHAPTER ? parseInt(process.env.VUE_APP_INITIAL_CHAPTER) : 0;
const state = reactive<State>({
  activeIndex: initialChapter,
  chapterToLoad: null,
  
  isListing: false,
  isGrabbing: false,

  isLoading: true,
  allowSwipe: false,
  showLoadingLight: true,
  showLoader: true,
  showNavigation: false,
  fontLoaded: false,

  loadProgress: 0,

  scrollProgress: 0,
  swipeX: 0,
})

const app: Ref<HTMLElement | null> = ref(null);

let goToNextChapter: () => void = () => {
  console.warn('goToNextChapter not registered');
};
const registerGoToNextChapter = (fn: () => void) => {
  goToNextChapter = fn;
}

const useChapterState = () => {
  
  return {
    state,
    app,
    goToNextChapter,
    registerGoToNextChapter
  }
}

export default useChapterState;